import { Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { ContentGetQuery, ContentGetQueryResult } from "../../INTEGRA_Shop_Client";

@Injectable({
  providedIn: 'root'
})
export abstract class IContentApiService {
  abstract swagContentGet(query: ContentGetQuery): Observable<ContentGetQueryResult>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IContentApiServiceToken = new InjectionToken<IContentApiService>('IContentApiServiceToken');
